export const ThemeKey = 'MINDPLUS-CONFIG-theme'
export const LocaleKey = 'MINDPLUS-CONFIG-locale'

// 纯React版本使用localStorage缓存配置
class Config {
    _config = {}

    private initPromise: Promise<void>;

    constructor() {
        this.initPromise = this.init();
    }
 
    async init() {
        try {
            const stored = localStorage.getItem('mindplus-config');
            if (stored) {
                this._config = JSON.parse(stored);
            } else {
                this._config = {};
            }
        } catch (error) {
            console.log("读取配置文件失败", error);
            this._config = {};
        }
    }
    
    waitForInit(): Promise<void> {
        return this.initPromise;
    }

    getItem(name: string) {
        return (this._config as Record<string, any>)[name];
    }

    async setItem(name: string, data: any) {
        (this._config as Record<string, any>)[name] = data;
        try {
            localStorage.setItem('mindplus-config', JSON.stringify(this._config));
        } catch (error) {
            console.log("保存配置文件失败", error);
        }
    }
}

export const globalConfig = new Config();
